"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsonwebtoken_1 = require("jsonwebtoken");

var dexie_db_1 = __importDefault(require("./dexie-db"));

var SounditiApi_1 = __importDefault(require("../SounditiApi"));

var Auth_1 = __importDefault(require("../Auth"));

var defaults_1 = __importDefault(require("../defaults"));

var logger_1 = __importDefault(require("../utils/logger"));

var errors_1 = require("../utils/errors");

var utils_1 = require("../utils/utils");

var prices_1 = require("../utils/prices");

var logger = logger_1.default('campaign-access');
/**
 * Provides access to the campaigns data to a web application
 * @class
 *
 * @param {string} [host = defaults.host] | the api host
 *
 * @category DataLayers
 *
 * @example
 * // TEST METHOD FOR USING WITHIN A REACT COMPONENT
 * // in the render method call this one like:
 * // <button onClick={() => this.runTests('createCampaign')}>CREATE CAMPAIGN</button>
 *
 * runTests = async event => {
 *   const { campaignID } = this.state;
 *   const campaignAccess= new CampaignAccess()
 *   let result;
 *   try {
 *       switch (event) {
 *           case "getCampaigns":
 *               // GET CAMAPIGNS
 *               result = await campaignAccess.getCampaigns('refresh');
 *               const campaignOptions = this.campaignListToOptions(result)
 *               this.setState({ campaignOptions })
 *               break;
 *           case "getCampaignByID":
 *               result = await campaignAccess.getCampaignbyID(campaignID)
 *               this.setState({ result: result.data.name})
 *               break;
 *           case "createCampaign":
 *               result = await campaignAccess.createCampaign({name: 'New Campaign'});
 *               this.setState({result : result.data.name}
 *           case "updateCampaign":
 *               result = await campaignAccess.updateCampaign(campaignID, {"name": "test"})
 *               this.setState({ campaign: result })
 *               break;
 *           case "previewCampaign":
 *               result = await campaignAccess.changeStatus(campaignID)
 *               console.log(result.previewUrl);
 *               const previewToken = result.previewToken;
 *               this.setState({ campaign: result, previewToken })
 *               break;
 *           case "deleteCampaign":
 *               result = await campaignAccess.deleteCampaign(campaignID);
 *               this.setState({result : result.data.name})
 *           default:
 *               break;
 *       }
 *   } catch (error) {
 *       console.log('ERROR NAME', error.name, error.message)
 *       if(error.name === 'PermissionError') {
 *       } else if (error.name === 'NotFoundError') {
 *       } else {
 *       }
 *       this.setState({ result: error.name})
 *   }
 * }
 *
 * @todo autorenew token with api if token expired
 */

var CampaignAccess = function () {
  /**
   *
   * @param {DataLayerConfiguration} options
   * @param {token} [options.token = ''] | An access token
   * @param {host} [options.hosts = defaults.host] | An access token
   *
   */
  function CampaignAccess(_a) {
    var _b = (_a === void 0 ? {} : _a).hosts,
        hosts = _b === void 0 ? defaults_1.default : _b;
    this._authRenewal = utils_1.tokenRenewal;
    this.auth = new Auth_1.default({
      auth_host: hosts.auth_host
    });
    this.token = this.auth.getToken() || '';
    this.api = new SounditiApi_1.default({
      token: this.token,
      hosts: hosts
    });
    this.table = 'campaigns';
  }
  /**
   * Get all campaign for the current user.
   *
   * It provides three operation modes:
   * <ul style="list-style: none;">
   * <li> - default : get updates from db and save changes to local.
   * <li> - local: don't call the db and returns only locally stored values.
   * <li> - refresh: deletes localDB and retrieves all campaigns from cloud storage.
   * </ul>
   *
   * @param {string} [mode = ''] defines the mode of operation:
   * @param {boolean} [renew = true] if true will try to renew accessToken on first PermissionError
   *
   * @throws {PermissionError} 403 responses or bad token
   *
   * @returns {Promise<CampaignItem[]>} a list of campaign items
   */


  CampaignAccess.prototype.getCampaigns = function (mode, renew) {
    if (mode === void 0) {
      mode = 'refresh';
    }

    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var update, refresh, payload, userID, campaigns, campaigns_1, json, error_1, updatedAt, res, new_campaignsItems, new_campaigns, old_campaigns_ids_1, new_campaigns_ids_1, to_update, to_add, to_maintain, campaigns_2, error_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            update = true;
            refresh = false;

            switch (mode) {
              case 'local':
                update = false;
                refresh = false;
                break;

              case 'refresh':
                update = true;
                refresh = true;
                break;

              default:
                update = true;
                refresh = false;
                break;
            }

            _a.label = 1;

          case 1:
            _a.trys.push([1, 19,, 20]);

            if (!refresh) return [3
            /*break*/
            , 3];
            logger.debug('getCampaigns deletes localDB');
            return [4
            /*yield*/
            , dexie_db_1.default.table(this.table).clear()];

          case 2:
            _a.sent();

            _a.label = 3;

          case 3:
            payload = jsonwebtoken_1.decode(this.token);
            userID = payload.sub;
            return [4
            /*yield*/
            , dexie_db_1.default.table(this.table).where('userId').equals(userID).toArray()];

          case 4:
            campaigns = _a.sent();

            if (!update) {
              logger.debug('getCampaigns from db: NO UPDATE');
              return [2
              /*return*/
              , campaigns];
            }

            if (!(campaigns.length === 0)) return [3
            /*break*/
            , 10];
            _a.label = 5;

          case 5:
            _a.trys.push([5, 8,, 9]);

            return [4
            /*yield*/
            , this.api.listCampaigns()];

          case 6:
            campaigns_1 = _a.sent();
            return [4
            /*yield*/
            , campaigns_1.json()];

          case 7:
            json = _a.sent();
            logger.debug('getCampaigns from API:', json);
            dexie_db_1.default.table(this.table).bulkAdd(json.Items);
            return [2
            /*return*/
            , json.Items];

          case 8:
            error_1 = _a.sent();
            throw new errors_1.DatabaseError('buldAdd error ');

          case 9:
            return [3
            /*break*/
            , 18];

          case 10:
            updatedAt = Math.max.apply(Math, campaigns.map(function (i) {
              return i.updatedAt;
            }));
            return [4
            /*yield*/
            , this.api.listCampaignsSinceUpdateAt(updatedAt + 1)];

          case 11:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 14];
            return [4
            /*yield*/
            , res.json()];

          case 12:
            new_campaignsItems = _a.sent();
            new_campaigns = new_campaignsItems.Items;
            old_campaigns_ids_1 = campaigns.map(function (c) {
              return c.campaignId;
            });
            new_campaigns_ids_1 = new_campaigns.map(function (c) {
              return c.campaignId;
            });
            to_update = new_campaigns.filter(function (c) {
              return old_campaigns_ids_1.includes(c.campaignId);
            });
            to_add = new_campaigns.filter(function (c) {
              return !old_campaigns_ids_1.includes(c.campaignId);
            });
            to_maintain = campaigns.filter(function (c) {
              return !new_campaigns_ids_1.includes(c.campaignId);
            });
            return [4
            /*yield*/
            , dexie_db_1.default.table(this.table).bulkPut(new_campaigns)];

          case 13:
            _a.sent();

            logger.debug('getCampaigns from db with updates from API:', [campaigns.length]);
            return [2
            /*return*/
            , __spreadArrays(to_update, to_add, to_maintain)];

          case 14:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 17];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 15:
            _a.sent();

            return [4
            /*yield*/
            , this.getCampaigns('', false)];

          case 16:
            campaigns_2 = _a.sent();
            return [2
            /*return*/
            , campaigns_2];

          case 17:
            throw new errors_1.PermissionError('Invalid access token');

          case 18:
            return [3
            /*break*/
            , 20];

          case 19:
            error_2 = _a.sent();
            logger.error('Error getting campaigns', {
              msg: error_2.message,
              name: error_2.name
            });
            throw new errors_1.PermissionError(error_2.message);

          case 20:
            ;
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  /**
   * Return campaigns by id owned by the authenticated user.
   *
   * It provides three operation modes:
   * <ul style="list-style: none;">
   * <li> - default : get updates from db and save changes to local.
   * <li> - local: don't call the db and returns only locally stored values.
   * <li> - refresh: deletes localDB and retrieves all campaigns from cloud storage.
   * </ul>
   *
   * @param {string} campaignId The id of the campaign
   * @param {string} [mode = ''] defines the mode of operation:
   * @param {boolean} [renew = true] if true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<CampaignItem>} the campaign item
   *
   * @throws {PermissionError} 403 responses or bad token
   * @throws {NotFoundError} campaign item wasn't found
   */

  CampaignAccess.prototype.getCampaignbyID = function (campaignId, mode, renew) {
    if (mode === void 0) {
      mode = "";
    }

    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var update, refresh, campaign, res, campaign_1, campaign_2, e, error_3;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            update = true;
            refresh = false;

            switch (mode) {
              case 'local':
                update = false;
                refresh = false;
                break;

              case 'refresh':
                update = true;
                refresh = true;
                break;

              default:
                update = true;
                refresh = false;
                break;
            }

            _a.label = 1;

          case 1:
            _a.trys.push([1, 15,, 16]);

            if (!refresh) return [3
            /*break*/
            , 3];
            logger.debug('getCampaigns deletes localDB');
            return [4
            /*yield*/
            , dexie_db_1.default.table(this.table).where('campaignId').equals(campaignId).delete()];

          case 2:
            _a.sent();

            _a.label = 3;

          case 3:
            return [4
            /*yield*/
            , dexie_db_1.default.table(this.table).where('campaignId').equals(campaignId).toArray()];

          case 4:
            campaign = _a.sent();

            if (!update) {
              logger.debug('getCampaignbyId from db: NO UPDATE');
              return [2
              /*return*/
              , campaign[0]];
            }

            if (!(campaign.length === 0)) return [3
            /*break*/
            , 14];
            return [4
            /*yield*/
            , this.api.getCampaign(campaignId)];

          case 5:
            res = _a.sent();
            if (!res.ok) return [3
            /*break*/
            , 7];
            return [4
            /*yield*/
            , res.json()];

          case 6:
            campaign_1 = _a.sent();
            logger.debug('getCampaignbyID from API', __assign({}, campaign_1));
            dexie_db_1.default.table(this.table).add(campaign_1);
            return [2
            /*return*/
            , campaign_1];

          case 7:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 10];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 8:
            _a.sent();

            return [4
            /*yield*/
            , this.getCampaignbyID(campaignId, "", false)];

          case 9:
            campaign_2 = _a.sent();
            return [2
            /*return*/
            , campaign_2];

          case 10:
            if (!(res.status === 404)) return [3
            /*break*/
            , 11];
            logger.error('getCampaignbyID status 404');
            throw new errors_1.NotFoundError('NotFound');

          case 11:
            if (!(res.status === 400)) return [3
            /*break*/
            , 13];
            return [4
            /*yield*/
            , res.json()];

          case 12:
            e = _a.sent();
            logger.error('getCampaignbyID status 400', {
              e: e
            });
            throw new errors_1.NotFoundError(e.message);

          case 13:
            throw new errors_1.PermissionError('Invalid access token');

          case 14:
            ;
            logger.debug('getCampaignbyID from DB', __assign({}, campaign));
            return [2
            /*return*/
            , campaign[0]];

          case 15:
            error_3 = _a.sent();
            logger.error('getCampaignbyID', {
              error: error_3
            });
            throw error_3;

          case 16:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  /**
   * Creates a new campaign that will be owned by the account holder
   *
   * @param {object} data The data of the campaign
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<CampaignItem>} New Campaign object
   *
   * @throws {PermissionError} 403 responses or bad token
   */

  CampaignAccess.prototype.createCampaign = function (data, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, json, campaign, error_4;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 9,, 10]);

            return [4
            /*yield*/
            , this.api.createCampaign({
              data: data
            })];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 4];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            json = _a.sent();
            logger.debug('campaign created in DynamoDB', __assign({}, json));
            return [4
            /*yield*/
            , dexie_db_1.default.table(this.table).put(json)];

          case 3:
            _a.sent();

            logger.debug('createCampaign', {
              json: json
            });
            return [2
            /*return*/
            , json];

          case 4:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 7];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 5:
            _a.sent();

            return [4
            /*yield*/
            , this.createCampaign(data, false)];

          case 6:
            campaign = _a.sent();
            return [2
            /*return*/
            , campaign];

          case 7:
            throw new errors_1.PermissionError('Invalid access token');

          case 8:
            return [3
            /*break*/
            , 10];

          case 9:
            error_4 = _a.sent();
            logger.error('Error creating campaign', {
              msg: error_4.message,
              name: error_4.name
            });
            throw new errors_1.PermissionError(error_4.message);

          case 10:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Warning: replaces the entire data of the campaign
   *
   * Updates a campaign owned by the token holder
   * provided the entire data object and the campaignID
   *
   * @param {string} campaignId The campaign id
   * @param {object} data The campaign data object
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @return {Promise<CampaignItem>} The updated campaign
   *
   * @throws {UpdateError} When user tries to updated a paid or a public campaign
   * @throws {PermissionError} 403 responses or bad token
   */


  CampaignAccess.prototype.updateCampaign = function (campaignId, data, createCampaignDataVersion, renew) {
    if (createCampaignDataVersion === void 0) {
      createCampaignDataVersion = true;
    }

    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, campaign, campaign, e, error_5;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 11,, 12]);

            return [4
            /*yield*/
            , this.api.updateCampaign(campaignId, {
              data: data
            }, createCampaignDataVersion)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 4];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            campaign = _a.sent();
            return [4
            /*yield*/
            , dexie_db_1.default.table(this.table).put(campaign)];

          case 3:
            _a.sent();

            logger.debug('updateCampaign: campaign updated', __assign({}, campaign));
            return [2
            /*return*/
            , campaign];

          case 4:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 7];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 5:
            _a.sent();

            return [4
            /*yield*/
            , this.updateCampaign(campaignId, data, createCampaignDataVersion, false)];

          case 6:
            campaign = _a.sent();
            return [2
            /*return*/
            , campaign];

          case 7:
            if (!(res.status === 400)) return [3
            /*break*/
            , 9];
            return [4
            /*yield*/
            , res.json()];

          case 8:
            e = _a.sent();
            logger.debug('res status 400', {
              e: e
            });
            throw new errors_1.UpdateError(e.message);

          case 9:
            throw new errors_1.PermissionError('Invalid access token');

          case 10:
            return [3
            /*break*/
            , 12];

          case 11:
            error_5 = _a.sent();
            logger.error('Error updating campaign', {
              msg: error_5.message,
              name: error_5.name
            });
            throw error_5;

          case 12:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Deletes a campaign owned by the token holder
   *
   * @param {string} campaignId the campaignID
   * @param {boolean} [renew = true] if true will try to renew accessToken on first PermissionError
   *
   * @throws {PermissionError} 403 responses or bad token
   *
   * @returns {string} Returns '' if the campaign was deleted
   */


  CampaignAccess.prototype.deleteCampaign = function (campaignId, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, error_6, error_7;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 11,, 12]);

            return [4
            /*yield*/
            , this.api.deleteCampaign(campaignId)];

          case 1:
            res = _a.sent();
            logger.debug(res);
            if (!(res.status === 200)) return [3
            /*break*/
            , 6];
            _a.label = 2;

          case 2:
            _a.trys.push([2, 4,, 5]);

            return [4
            /*yield*/
            , dexie_db_1.default.table(this.table).delete(campaignId)];

          case 3:
            _a.sent();

            return [3
            /*break*/
            , 5];

          case 4:
            error_6 = _a.sent();
            throw error_6;

          case 5:
            logger.debug('deleteCampaign', {
              campaignId: campaignId
            });
            return [3
            /*break*/
            , 10];

          case 6:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 9];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 7:
            _a.sent();

            return [4
            /*yield*/
            , this.deleteCampaign(campaignId, false)];

          case 8:
            _a.sent();

            return [3
            /*break*/
            , 10];

          case 9:
            throw new errors_1.PermissionError('Invalid access token');

          case 10:
            return [3
            /*break*/
            , 12];

          case 11:
            error_7 = _a.sent();
            logger.error('deleteCampaign', __assign({}, error_7));
            logger.error('Error deleting campaign', {
              msg: error_7.message,
              name: error_7.name
            });
            throw new errors_1.PermissionError(error_7.message);

          case 12:
            return [2
            /*return*/
            , ''];
        }
      });
    });
  };
  /**
   * Toogles a campaign status between draft|preview and
   * generates or updates 'preview_password' and 'preview_token'
   * for preview and paid campaigns
   *
   * @param {string} campaignId The campaignID
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @return {Promise<CampaignItem>} the toogled campaign
   *
   * @throws {PermissionError} 403 responses or bad token
   */


  CampaignAccess.prototype.changeStatus = function (campaignId, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, campaign, campaign, error_8;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 9,, 10]);

            return [4
            /*yield*/
            , this.api.previewCampaign(campaignId)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 4];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            campaign = _a.sent();
            return [4
            /*yield*/
            , dexie_db_1.default.table(this.table).put(campaign)];

          case 3:
            _a.sent();

            logger.debug('changeStatus: campaign updated', __assign({}, campaign));
            return [2
            /*return*/
            , campaign];

          case 4:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 7];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 5:
            _a.sent();

            return [4
            /*yield*/
            , this.changeStatus(campaignId, false)];

          case 6:
            campaign = _a.sent();
            return [2
            /*return*/
            , campaign];

          case 7:
            throw new errors_1.PermissionError('Invalid access token');

          case 8:
            return [3
            /*break*/
            , 10];

          case 9:
            error_8 = _a.sent();
            logger.error('Error updating campaign', {
              msg: error_8.message,
              name: error_8.name
            });
            throw new errors_1.PermissionError(error_8.message);

          case 10:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Sends a campaign to processing
   *
   * @param {string} campaignId The campaign id
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @return {Promise<CampaignItem>} The toogled campaign
   *
   * @throws {PermissionError} 403 responses or bad token
   */


  CampaignAccess.prototype.sendToProcessing = function (campaignId, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, campaign, campaign, error_9;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 9,, 10]);

            return [4
            /*yield*/
            , this.api.sendToProcess(campaignId)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 4];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            campaign = _a.sent();
            return [4
            /*yield*/
            , dexie_db_1.default.table(this.table).put(campaign)];

          case 3:
            _a.sent();

            logger.debug('changeStatus: campaign updated', __assign({}, campaign));
            return [2
            /*return*/
            , campaign];

          case 4:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 7];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 5:
            _a.sent();

            return [4
            /*yield*/
            , this.sendToProcessing(campaignId, false)];

          case 6:
            campaign = _a.sent();
            return [2
            /*return*/
            , campaign];

          case 7:
            throw new errors_1.PermissionError('Invalid access token');

          case 8:
            return [3
            /*break*/
            , 10];

          case 9:
            error_9 = _a.sent();
            logger.error('Error updating campaign', {
              msg: error_9.message,
              name: error_9.name
            });
            throw new errors_1.PermissionError(error_9.message);

          case 10:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Clones a campaign
   *
   * @param {string} campaignId the origin campaignID
   * @param {boolean} [renew = true] if true will try to renew accessToken on first PermissionError
   *
   * @return {Promise<CampaignItem>} the new campaign
   *
   * @throws {PermissionError} 403 responses or bad token
   */


  CampaignAccess.prototype.cloneCampaign = function (campaignId, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, campaign, campaign, error_10;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 9,, 10]);

            return [4
            /*yield*/
            , this.api.cloneCampaign(campaignId)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 4];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            campaign = _a.sent();
            return [4
            /*yield*/
            , dexie_db_1.default.table(this.table).put(campaign)];

          case 3:
            _a.sent();

            logger.debug('cloneCampaign: campaign cloned', __assign({}, campaign));
            return [2
            /*return*/
            , campaign];

          case 4:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 7];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 5:
            _a.sent();

            return [4
            /*yield*/
            , this.cloneCampaign(campaignId, false)];

          case 6:
            campaign = _a.sent();
            return [2
            /*return*/
            , campaign];

          case 7:
            throw new errors_1.PermissionError('Invalid access token');

          case 8:
            return [3
            /*break*/
            , 10];

          case 9:
            error_10 = _a.sent();
            logger.error('Error updating campaign', {
              msg: error_10.message,
              name: error_10.name
            });
            throw new errors_1.PermissionError(error_10.message);

          case 10:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Returns the campaign price
   *
   * @param {CampaignItem} campaign the complete campaign item
   *
   * @returns {number} Price in Euro cents => 100 = 1€
   */


  CampaignAccess.prototype.campaignCost = function (campaign) {
    return prices_1.campaignPriceCalculator(campaign);
  };
  /**
   * Check if a campaign is under free tier and its price
   *
   * @param {CampaignItem} campaign the complete campaign item
   *
   * @returns {FreeTierResponse}
   */


  CampaignAccess.prototype.isFreeTier = function (campaign) {
    return prices_1.isFreeTier(campaign);
  };
  /**
   * Creates a new link related with a campaign
   *
   * @param {CreateLinkRequest} link The link request object with the campaignId, the alias, and if it is link and/or active
   * @param {boolean} [withStatistics = false] If true will return the link statistics
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<Link>} New Link object
   *
   * @throws {PermissionError} 403 Responses or bad token
   * @throws {Error} 40X Generic error
   */


  CampaignAccess.prototype.createLink = function (link, withStatistics, renew) {
    if (withStatistics === void 0) {
      withStatistics = false;
    }

    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, json, res_1, error_11;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 8,, 9]);

            return [4
            /*yield*/
            , this.api.createLink(link, withStatistics)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            json = _a.sent();
            logger.debug('link created in DynamoDB', __assign({}, json));
            return [2
            /*return*/
            , json];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.createLink(link, withStatistics, false)];

          case 5:
            res_1 = _a.sent();
            return [2
            /*return*/
            , res_1];

          case 6:
            if (res.status === 402) {
              throw new Error('The maximum number of tests has been reached');
            } else {
              throw new errors_1.PermissionError('Invalid access token');
            }

            _a.label = 7;

          case 7:
            return [3
            /*break*/
            , 9];

          case 8:
            error_11 = _a.sent();
            logger.error('Error creating link', {
              msg: error_11.message,
              name: error_11.name
            });
            throw new Error(error_11);

          case 9:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Gets all the links of a campaign
   *
   * @param {string} campaignId The campaign identifier
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<Link[]>} The links list of a campaign
   *
   * @throws {PermissionError} 403 responses or bad token
   */


  CampaignAccess.prototype.getLinks = function (campaignId, withStatistics, renew) {
    if (withStatistics === void 0) {
      withStatistics = true;
    }

    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, links, links, e, error_12;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 11,, 12]);

            return [4
            /*yield*/
            , this.api.getLinks(campaignId, withStatistics)];

          case 1:
            res = _a.sent();
            if (!res.ok) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            links = _a.sent();
            logger.debug('getLinks from API', __assign({}, links));
            return [2
            /*return*/
            , links];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.getLinks(campaignId, withStatistics, false)];

          case 5:
            links = _a.sent();
            return [2
            /*return*/
            , links];

          case 6:
            if (!(res.status === 404)) return [3
            /*break*/
            , 7];
            logger.error('getLinks status 404');
            throw new errors_1.NotFoundError('NotFound');

          case 7:
            if (!(res.status === 400)) return [3
            /*break*/
            , 9];
            return [4
            /*yield*/
            , res.json()];

          case 8:
            e = _a.sent();
            logger.error('getLinks status 400', {
              e: e
            });
            throw new errors_1.NotFoundError(e.message);

          case 9:
            throw new errors_1.PermissionError('Invalid access token');

          case 10:
            return [3
            /*break*/
            , 12];

          case 11:
            error_12 = _a.sent();
            logger.error('Error getLinks', {
              msg: error_12.message,
              name: error_12.name
            });
            throw new Error(error_12.message);

          case 12:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Updates a link
   *
   * @param {Link} link The link object with the new changes
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @return {Promise<Link>} The updated link object
   *
   * @throws {PermissionError} 403 responses or bad token
   */


  CampaignAccess.prototype.updateLink = function (link, withStatistics, renew) {
    if (withStatistics === void 0) {
      withStatistics = false;
    }

    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, updatedLink, updatedLink, error_13;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 8,, 9]);

            return [4
            /*yield*/
            , this.api.updateLink(link, withStatistics)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            updatedLink = _a.sent();
            logger.debug('link updated', __assign({}, updatedLink));
            return [2
            /*return*/
            , updatedLink];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.updateLink(link, withStatistics, false)];

          case 5:
            updatedLink = _a.sent();
            return [2
            /*return*/
            , updatedLink];

          case 6:
            throw new errors_1.PermissionError('Invalid access token');

          case 7:
            return [3
            /*break*/
            , 9];

          case 8:
            error_13 = _a.sent();
            logger.error('Error updateLink', {
              msg: error_13.message,
              name: error_13.name
            });
            throw new Error(error_13.message);

          case 9:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Gets a link object giving the link url
   *
   * @param {string} linkUrl The link url
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<Link>} The links list of a campaign
   *
   * @throws {Error} 403 responses or bad token
   */


  CampaignAccess.prototype.getLinkByUrl = function (linkUrl, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, link, link, e, error_14;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 11,, 12]);

            return [4
            /*yield*/
            , this.api.getLinkByUrl(linkUrl)];

          case 1:
            res = _a.sent();
            if (!res.ok) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            link = _a.sent();
            logger.debug('getLinkByUrl from API', __assign({}, link));
            return [2
            /*return*/
            , link];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.getLinkByUrl(linkUrl, false)];

          case 5:
            link = _a.sent();
            return [2
            /*return*/
            , link];

          case 6:
            if (!(res.status === 404)) return [3
            /*break*/
            , 7];
            logger.error('getLinkByUrl status 404');
            throw new errors_1.NotFoundError('NotFound');

          case 7:
            if (!(res.status === 400)) return [3
            /*break*/
            , 9];
            return [4
            /*yield*/
            , res.json()];

          case 8:
            e = _a.sent();
            logger.error('getLinkByUrl status 400', {
              e: e
            });
            throw new errors_1.NotFoundError(e.message);

          case 9:
            throw new errors_1.PermissionError('Invalid access token');

          case 10:
            return [3
            /*break*/
            , 12];

          case 11:
            error_14 = _a.sent();
            logger.error('Error getLinkByUrl', {
              msg: error_14.message,
              name: error_14.name
            });
            throw new Error(error_14.message);

          case 12:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Gets a link object giving the link url
   *
   * @param {string} linkUrl The link url
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<boolean>} The links list of a campaign
   *
   * @throws {PermissionError} 403 responses or bad token
   */


  CampaignAccess.prototype.checkAvailableUrl = function (linkUrl, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, isAvailable, isAvailable, e, error_15;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 11,, 12]);

            return [4
            /*yield*/
            , this.api.checkAvailableUrl(linkUrl)];

          case 1:
            res = _a.sent();
            if (!res.ok) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            isAvailable = _a.sent();
            logger.debug('checkAvailableUrl from API', __assign({}, isAvailable));
            return [2
            /*return*/
            , isAvailable];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.checkAvailableUrl(linkUrl, false)];

          case 5:
            isAvailable = _a.sent();
            return [2
            /*return*/
            , isAvailable];

          case 6:
            if (!(res.status === 404)) return [3
            /*break*/
            , 7];
            logger.error('checkAvailableUrl status 404');
            throw new errors_1.NotFoundError('NotFound');

          case 7:
            if (!(res.status === 400)) return [3
            /*break*/
            , 9];
            return [4
            /*yield*/
            , res.json()];

          case 8:
            e = _a.sent();
            logger.error('checkAvailableUrl status 400', {
              e: e
            });
            throw new errors_1.NotFoundError(e.message);

          case 9:
            throw new errors_1.PermissionError('Invalid access token');

          case 10:
            return [3
            /*break*/
            , 12];

          case 11:
            error_15 = _a.sent();
            logger.error('Error checkAvailableUrl', {
              msg: error_15.message,
              name: error_15.name
            });
            throw new Error(error_15.message);

          case 12:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Deletes a link
   *
   * @param {Link} link The link object with the new changes
   * @param {boolean} [renew = true] if true will try to renew accessToken on first PermissionError
   *
   * @throws {PermissionError} 403 responses or bad token
   *
   * @returns {Promise<Link>} The deleted link object
   */


  CampaignAccess.prototype.deleteLink = function (link, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, link_1, error_16;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 8,, 9]);

            return [4
            /*yield*/
            , this.api.deleteLink(link)];

          case 1:
            res = _a.sent();
            logger.debug(res);
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            link_1 = _a.sent();
            logger.debug('deleteLink', {
              link: link_1
            });
            return [2
            /*return*/
            , link_1];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.deleteLink(link, false)];

          case 5:
            _a.sent();

            return [3
            /*break*/
            , 7];

          case 6:
            throw new errors_1.PermissionError('Invalid access token');

          case 7:
            return [3
            /*break*/
            , 9];

          case 8:
            error_16 = _a.sent();
            logger.error('Error deleteLink', {
              msg: error_16.message,
              name: error_16.name
            });
            throw new Error(error_16.message);

          case 9:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Gets all the dataversions of a campaign
   *
   * @param {string} campaignId The campaign identifier
   * @param {number} [fromCreatedAt = 0] The timestamp from when the data were created
   * @param {number} [fromNumberOfVersion = 1] The minimum number of version to be returned
   * @param {number} [toNumberOfVersion = 50] The maximum number of version to be returned
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<CampaignVersion[]>} The CampaignVersions of a campaign
   *
   * @throws {PermissionError} 403 responses or bad token
   */


  CampaignAccess.prototype.getCampaignVersions = function (campaignId, numberOfPage, offset, fromCreatedAt, renew) {
    if (numberOfPage === void 0) {
      numberOfPage = 1;
    }

    if (offset === void 0) {
      offset = 50;
    }

    if (fromCreatedAt === void 0) {
      fromCreatedAt = 0;
    }

    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, campaignVersions, campaignVersions, e, error_17;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 11,, 12]);

            return [4
            /*yield*/
            , this.api.getCampaignVersions(campaignId, numberOfPage, offset, fromCreatedAt)];

          case 1:
            res = _a.sent();
            if (!res.ok) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            campaignVersions = _a.sent();
            logger.debug('getCampaignVersions from API', __assign({}, campaignVersions));
            dexie_db_1.default.table(this.table).add(campaignVersions);
            return [2
            /*return*/
            , campaignVersions];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.getCampaignVersions(campaignId, numberOfPage, offset, fromCreatedAt, false)];

          case 5:
            campaignVersions = _a.sent();
            return [2
            /*return*/
            , campaignVersions];

          case 6:
            if (!(res.status === 404)) return [3
            /*break*/
            , 7];
            logger.error('getCampaignVersions status 404');
            throw new errors_1.NotFoundError('NotFound');

          case 7:
            if (!(res.status === 400)) return [3
            /*break*/
            , 9];
            return [4
            /*yield*/
            , res.json()];

          case 8:
            e = _a.sent();
            logger.error('getCampaignVersions status 400', {
              e: e
            });
            throw new errors_1.NotFoundError(e.message);

          case 9:
            throw new errors_1.PermissionError('Invalid access token');

          case 10:
            return [3
            /*break*/
            , 12];

          case 11:
            error_17 = _a.sent();
            logger.error('Error getCampaignVersions', {
              msg: error_17.message,
              name: error_17.name
            });
            throw new Error(error_17.message);

          case 12:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Updates a campaign version
   *
   * @param {string} campaignId The campaign identifier
   * @param {number} createdAt The timestamp when the version was created
   * @param {string} name The name of the version
   *
   * @returns {Promise<CampaignVersion>} The CampaignVersion  object
   */


  CampaignAccess.prototype.updateCampaignVersion = function (campaignId, createdAt, name, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, updatedCampaignVersion, updatedCampaignVersion, error_18;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 9,, 10]);

            return [4
            /*yield*/
            , this.api.updateCampaignVersion(campaignId, createdAt, name)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 4];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            updatedCampaignVersion = _a.sent();
            return [4
            /*yield*/
            , dexie_db_1.default.table(this.table).put(updatedCampaignVersion)];

          case 3:
            _a.sent();

            logger.debug('CampaignVersion updated', __assign({}, updatedCampaignVersion));
            return [2
            /*return*/
            , updatedCampaignVersion];

          case 4:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 7];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 5:
            _a.sent();

            return [4
            /*yield*/
            , this.updateCampaignVersion(campaignId, createdAt, name, false)];

          case 6:
            updatedCampaignVersion = _a.sent();
            return [2
            /*return*/
            , updatedCampaignVersion];

          case 7:
            throw new errors_1.PermissionError('Invalid access token');

          case 8:
            return [3
            /*break*/
            , 10];

          case 9:
            error_18 = _a.sent();
            logger.error('Error updateCampaignVersion', {
              msg: error_18.message,
              name: error_18.name
            });
            throw new Error(error_18.message);

          case 10:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  /**
   * Creates testers related with a campaidn
   *
   * @param {string} campaignId The campaign identifier
   * @param {string[]} emails A list with the emails of the testers
   *
   * @returns {Promise<TesterItem[]>} The module with choose tech metrics
   *
   * @throws {PermissionError} Auth token not valid
   */

  CampaignAccess.prototype.addTestersToCampaign = function (emails, campaignId, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, testers, testers, error_19;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 8,, 9]);

            return [4
            /*yield*/
            , this.api.addTestersToCampaign(emails, campaignId)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            testers = _a.sent();
            logger.debug('addTestersToCampaign updated', __assign({}, testers));
            return [2
            /*return*/
            , testers];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.addTestersToCampaign(emails, campaignId, false)];

          case 5:
            testers = _a.sent();
            return [2
            /*return*/
            , testers];

          case 6:
            throw new errors_1.PermissionError('Invalid access token');

          case 7:
            return [3
            /*break*/
            , 9];

          case 8:
            error_19 = _a.sent();
            logger.error('Error addTestersToCampaign', {
              msg: error_19.message,
              name: error_19.name
            });
            throw new Error(error_19.message);

          case 9:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  /**
   * Reactivates a tester froma film campaign
   *
   * @param {string} campaignId The campaign identifier
   * @param {string} emails The email of the tester to reactivate
   *
   * @returns {Promise<TesterItem>} The tester item updated
   *
   * @throws {PermissionError} Auth token not valid
   */

  CampaignAccess.prototype.reactivateFilmTester = function (email, campaignId, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, tester, tester, error_20;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 8,, 9]);

            return [4
            /*yield*/
            , this.api.reactivateFilmTester(email, campaignId)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            tester = _a.sent();
            logger.debug('reactivateFilmTester updated', __assign({}, tester));
            return [2
            /*return*/
            , tester];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.reactivateFilmTester(email, campaignId, false)];

          case 5:
            tester = _a.sent();
            return [2
            /*return*/
            , tester];

          case 6:
            throw new errors_1.PermissionError('Invalid access token');

          case 7:
            return [3
            /*break*/
            , 9];

          case 8:
            error_20 = _a.sent();
            logger.error('Error reactivateFilmTester', {
              msg: error_20.message,
              name: error_20.name
            });
            throw new Error(error_20.message);

          case 9:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  return CampaignAccess;
}();

;
exports.default = CampaignAccess;